import { css, html, LitElement } from 'lit';
import { CanCloseMixin, ProvidesCanCloseToSlotsMixin } from '../modal/util.js';
import { reset } from '../styles.js';
/**
 * The footer section of a modal, typically where you place actions.
 *
 * [See Storybook for usage examples](https://warp-ds.github.io/elements/?path=/docs/overlays-modal--docs)
 */
export class ModalFooter extends CanCloseMixin(ProvidesCanCloseToSlotsMixin(LitElement)) {
    render() {
        return html `
      <div class="footer">
        <slot @slotchange="${this.handleSlotChange}"></slot>
      </div>
    `;
    }
    static { this.styles = [
        reset,
        css `
      .footer {
        display: flex;
        flex-shrink: 0;
        justify-content: flex-end;
        padding-left: 1.6rem;
        padding-right: 1.6rem;
        padding-top: 2.4rem;
      }
      @media (min-width: 480px) {
        .footer {
          padding-left: 3.2rem;
          padding-right: 3.2rem;
        }
      }
    `,
    ]; }
}
if (!customElements.get('w-modal-footer')) {
    customElements.define('w-modal-footer', ModalFooter);
}
//# sourceMappingURL=modal-footer.js.map